module.exports = __webpack_public_path__ + "static/media/schwifty.5079af06.wav";